<template>
  <div>
    <app-cells><h2 class="title">Allocated beds</h2></app-cells>
    <v-client-table
      :data="table_allocated.items"
      :columns="table_allocated.columns"
      :options="table_allocated.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__clients><div class="table-default__left">Clients</div></template>
      <template #h__created_by><div class="table-default__left">Created by</div></template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.hotel.name }}</div></template>
      <template #check_in="{ row }">{{ dateFormat(row.check_in) }}</template>
      <template #check_out="{ row }">{{ dateFormat(row.check_out) }}</template>
      <template #clients="{ row }">
        <div class="table-default__left table-default__controls">
          <span
            :class="`fflag ff-md fflag-${row.rooms[0].clients[0].citizenship ? row.rooms[0].clients[0].citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.rooms[0].clients[0].citizenship ? row.rooms[0].clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.rooms[0].clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.rooms[0].clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.rooms[0].clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.rooms[0].clients[0].id } }"
            class="table-default__link-border"
          >
            {{ row.rooms[0].clients[0].full_name }}
          </router-link>
          <span v-if="row.rooms[0].clients[0].age">({{ row.rooms[0].clients[0].age }} y.o.)</span>
          |
          <span
            :class="`fflag ff-md fflag-${row.rooms[1].clients[0].citizenship ? row.rooms[1].clients[0].citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.rooms[1].clients[0].citizenship ? row.rooms[1].clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <img v-if="row.rooms[1].clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
          <img v-if="row.rooms[1].clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          <img v-if="!row.rooms[1].clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.rooms[1].clients[0].id } }"
            class="table-default__link-border"
          >
            {{ row.rooms[1].clients[0].full_name }}
          </router-link>
          <span v-if="row.rooms[1].clients[0].age">({{ row.rooms[1].clients[0].age }} y.o.)</span>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowDeleteModal(row.shareable_rooms_list_id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells><h2 class="title">Before</h2></app-cells>
    <v-client-table
      :data="table_before.items"
      :columns="table_before.columns"
      :options="table_before.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #select="{ row }">
        <label
          class="checkbox checkbox--table"
          :class="{ 'checkbox--readonly': checked_after.length > 0 || (checked_before.length >= 2 && !checked_before.includes(row.hotel_management_room)) }">
          <input
            v-model="checked_before"
            type="checkbox"
            :value="row.hotel_management_room"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.reservation.hotel.name }}</div></template>
      <template #check="{ row }">{{ dateFormat(row.check_out) }}</template>
      <template #name="{ row }"><div class="table-default__left table-default__controls">
        <span
          :class="`fflag ff-md fflag-${row.clients[0].citizenship ? row.clients[0].citizenship.code : 'empty'}`"
          v-tooltip="{ content: row.clients[0].citizenship ? row.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
        ></span>
        <img v-if="row.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
        <img v-if="row.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
        <img v-if="!row.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
        <router-link
          :to="{ name: 'clients-detail', params: { id: row.clients[0].id } }"
          class="table-default__link-border"
        >
          {{ row.clients[0].full_name }}
        </router-link>
        <span v-if="row.clients[0].age">({{ row.clients[0].age }} y.o.)</span>
      </div></template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.clients[0].manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.clients[0].manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.clients[0].group">
            <router-link
              :to="{ name: 'clients-groups-general', params: { id: row.clients[0].group.id } }"
              class="table-default__link-border"
            >
              {{ row.clients[0].group.name }}
            </router-link>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
    </v-client-table>
    <app-cells><h2 class="title">After</h2></app-cells>
    <v-client-table
      :data="table_after.items"
      :columns="table_after.columns"
      :options="table_after.options"
      class="table-default"
    >
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #h__name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #select="{ row }">
        <label
          class="checkbox checkbox--table"
          :class="{ 'checkbox--readonly': checked_before.length > 0 || (checked_after.length >= 2 && !checked_after.includes(row.hotel_management_room)) }">
          <input
            v-model="checked_after"
            type="checkbox"
            :value="row.hotel_management_room"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #hotel="{ row }"><div class="table-default__left">{{ row.reservation.hotel.name }}</div></template>
      <template #check="{ row }">{{ dateFormat(row.check_in) }}</template>
      <template #name="{ row }"><div class="table-default__left table-default__controls">
        <span
          :class="`fflag ff-md fflag-${row.clients[0].citizenship ? row.clients[0].citizenship.code : 'empty'}`"
          v-tooltip="{ content: row.clients[0].citizenship ? row.clients[0].citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
        ></span>
        <img v-if="row.clients[0].gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
        <img v-if="row.clients[0].gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
        <img v-if="!row.clients[0].gender" src="@/assets/img/gender-plug-icon.svg" alt="">
        <router-link
          :to="{ name: 'clients-detail', params: { id: row.clients[0].id } }"
          class="table-default__link-border"
        >
          {{ row.clients[0].full_name }}
        </router-link>
        <span v-if="row.clients[0].age">({{ row.clients[0].age }} y.o.)</span>
      </div></template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.clients[0].manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.clients[0].manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.clients[0].group">
            <router-link
              :to="{ name: 'clients-groups-general', params: { id: row.clients[0].group.id } }"
              class="table-default__link-border"
            >
              {{ row.clients[0].group.name }}
            </router-link>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
    </v-client-table>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected rooms: <span>{{ checked_before.length || checked_after.length }}</span></div>
      <app-button @click.native="onAllocateRooms" ref="allocate">Allocate</app-button>
    </div>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingGroupsBedInTwin,
  getClimbingGroupsJoinRoomingList,
  postClimbingGroupsJoinRoomingList,
  deleteClimbingGroupsJoinRoomingList, postHotelManagementReservationShareableRoomsList,
  getClimbingRoomsAllocatedBedInTwin
} from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'ClimbingGroupsDetailBedInTwin',
  data() {
    return {
      checked_before: [],
      checked_after: [],
      is_show_flying_block: false,
      item_to_action: null,
      table_before: {
        items: [],
        columns: ['select', 'hotel', 'check', 'name', 'group'],
        options: {
          headings: {
            select: '',
            hotel: 'Hotel',
            check: 'Check-out',
            name: 'Full name',
            group: 'Group',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_after: {
        items: [],
        columns: ['select', 'hotel', 'check', 'name', 'group'],
        options: {
          headings: {
            select: '',
            hotel: 'Hotel',
            check: 'Check-in',
            name: 'Full name',
            group: 'Group',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_allocated: {
        items: [],
        columns: ['hotel', 'check_in', 'check_out', 'clients', 'controls'],
        options: {
          headings: {
            hotel: 'Hotel',
            check_in: 'Check-in',
            check_out: 'Check-out',
            clients: 'Clients',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  watch: {
    checked_before(value) {
      this.is_show_flying_block = value.length >= 2
    },
    checked_after(value) {
      this.is_show_flying_block = value.length >= 2
    },
  },
  created() {
    this.fetchTableBefore()
    this.fetchTableAfter()
    this.fetchTableAllocated()
  },
  methods: {
    fetchTableBefore() {
      getClimbingGroupsBedInTwin(Number(this.$route.params.id), { category: 'before' })
        .then(response => {
          this.table_before.items = response.data
        })
    },
    fetchTableAfter() {
      getClimbingGroupsBedInTwin(Number(this.$route.params.id), { category: 'after' })
        .then(response => {
          this.table_after.items = response.data
        })
    },
    fetchTableAllocated() {
      getClimbingRoomsAllocatedBedInTwin(Number(this.$route.params.id))
        .then(response => {
          this.table_allocated.items = response.data
        })
    },
    onAllocateRooms() {
      this.$refs.allocate.preload = true
      postHotelManagementReservationShareableRoomsList({
        reservations: this.checked_before.length > 0 ? this.checked_before : this.checked_after,
      })
        .then(() => {
          this.fetchTableAllocated()
          this.is_show_flying_block = false
          if (this.checked_before.length > 0) {
            this.fetchTableBefore()
            this.checked_before = []
          } else {
            this.fetchTableAfter()
            this.checked_after = []
          }
          this.$refs.allocate.preload = false
        })
        .catch(() => { this.$refs.allocate.preload = false })
    },
    onDeleteItem() {
      this.$refs.delete.preload = true
      deleteClimbingGroupsJoinRoomingList(this.item_to_action)
        .then(() => {
          this.fetchTableBefore()
          this.fetchTableAfter()
          this.fetchTableAllocated()
          this.$modal.hide('delete-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onShowDeleteModal(id) {
      this.item_to_action = id
      this.$modal.show('delete-modal')
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
